import { API, METHODS, SCHEMAS } from "../../../shared/constants";

export const commonLoginSchema = {
  type: "object",
  required: ["token"],
  properties: {
    token: { type: "string" },
  },
  additionalProperties: false,
};

export default {
  [`${API.LOGIN}${SCHEMAS.REQUEST}${METHODS.POST}`]: {
    type: "object",
    required: ["email", "password"],
    properties: {
      email: { type: "string" },
      password: { type: "string" },
    },
    additionalProperties: false,
  },
  [`${API.LOGIN}${SCHEMAS.RESPONSE}${METHODS.POST}`]: commonLoginSchema,
};
